<div id="login-wrapper" class="posto-top">
    <div class="wrapper-size">
        <div class="login-header">
            <div class="header-logo header-auth-logo" id="popcheck">
                <a href="#" target="_blank" (click)="preventNavigation($event)"></a>
            </div>
        </div>

        <!-- login-page-header -->
        <div class="login-panel">
            <dropdown [disabled]="true" [combo]="countryCombo" [autoWidth]="false" [(ngModel)]="viewForm.areaType">
            </dropdown>
            <BR />
            <messages [value]="errorMessage"></messages>

            <!-- 顧客ID/代號  -->
            <div class="input-group " data-title="{{labeltBean.labelUserIxd}}">
                <input autocapitalize="off" [disabled]="true" class="input input-disabled" type="text"
                    placeholder="{{labeltBean.labelUserIxd}}" [(ngModel)]="viewForm.loginIxd" id="loginIxdText" />
                <span class="input-icon" (click)="clickLoginIxdPinEyeIcon('loginIxd')">
                    <i id="loginIxdEyeIcon" class="fa fa-eye"></i>
                </span>
            </div>

            <div class="input-group" data-title="{{labeltBean.labelUserName}}">
                <input #inputLoginIxd id="inputLoginIxd" [ngClass]="{'input-disabled': disabledLoginUserIxd }"
                    *ngIf="displayPxssForLoginIxd" [disabled]="disabledLoginUserIxd" autocapitalize="off" class="input"
                    type="password" placeholder="{{labeltBean.labelUserName}}" [(ngModel)]="loginUserIxdPin" />
                <input #inputLoginIxd id="inputLoginIxd" [ngClass]="{'input-disabled': disabledLoginUserIxd }"
                    *ngIf="!displayPxssForLoginIxd" [disabled]="disabledLoginUserIxd" autocapitalize="off" class="input"
                    type="text" placeholder="{{labeltBean.labelUserName}}" [(ngModel)]="loginUserIxdtxt" />
                <span class="input-icon" (click)="clickEyeIcon()">
                    <i id="eyeIcon" class="fa fa-eye"></i>
                </span>
            </div>

            <div class="input-group" [ngClass]="{'input-group is-hide':true }" id="pinInputGroup"
                data-title="{{labeltBean.labelPin}}">

                <pin #pinText [disabled]="disabledInput" autocapitalize="off" autocomplete="off" inputId="pinText"
                    inputStyleClass="input" [(ngModel)]="viewForm.loginPinValue" placeholder="{{labeltBean.labelPin}}"
                    (keydown)="onPinKeydown($event)"></pin>
                <span class="input-icon" (click)="clickLoginIxdPinEyeIcon('pin')">
                    <i id="pinEyeIcon" class="fa fa-eye-slash"></i>
                </span>
            </div>

            <div class="input-group" data-title="{{labeltBean.labelCaptcha}}">
                <input autocapitalize="off" [disabled]="disabledInput" class="input" type="text"
                    placeholder="{{labeltBean.labelCaptcha}}" (keydown)="onPinKeydown($event)"
                    [(ngModel)]="viewForm.captchaAnswer">
                <div class="input-icon">
                    <span class="code-img">
                        <img src="{{viewForm.serverUrl}}">
                    </span>
                    <a href="#" (click)="clickReloadCaptcha($event,false)">
                        <i class="fa fa-repeat"></i>
                    </a>
                </div>
            </div>

            <ccmotlgac-field-message [display]="viewForm.displayLoginIxdMessage" [message]="viewForm.loginIxdMessage">
            </ccmotlgac-field-message>

            <ccmotlgac-field-message [display]="viewForm.displayLoginUserIxdMessage"
                [message]="viewForm.loginUserIxdMessage">
            </ccmotlgac-field-message>

            <ccmotlgac-field-message [display]="viewForm.displayLoginPinMessage" [message]="viewForm.loginPinMessage">
            </ccmotlgac-field-message>

            <ccmotlgac-field-message [display]="viewForm.displayCaptchaAnswerMessage"
                [message]="viewForm.captchaAnswerMessage">
            </ccmotlgac-field-message>

            <div class="btn_box">
                <commandButton (onClick)="doLogin()" [disabled]="disabledInput" styleClass="submit_btn no-btn-ouline">
                    {{labeltBean.labelLoginButton}}</commandButton>
                <commandButton (onClick)="resetForm()" [disabled]="disabledInput"
                    styleClass="submit_btn reset no-btn-ouline">{{labeltBean.labelCleanButton}}</commandButton>
            </div>
        </div>

    </div>
    <!--/ wrapper-size-->
</div>

<div class="login-slider">
    <div class="login-slider-clip wid_100vw">

        <div id="loginSliderWrapper">
            <div class="login-item">
                <img src="{{defaultBackGround}}" alt="" id='iimg0'>
            </div>
        </div>

    </div>
    <div class="white-slash"></div>
</div>

<page-footer #pageFooter [isTask]="false"></page-footer>

<!-- #footer end-->
<div class="overlayer"></div>
<div class="overlayer_menu"></div>